import { connectSearchParamsToTableStore, initTableStore } from "../../../stores/TableStore.js";

export function initOrderTableStore() {
  return initTableStore()
}

export function connectSearchParamsToOrderTableStore(OrderTableStore, searchParams = new URLSearchParams(window.location.search)) {
  return connectSearchParamsToTableStore(OrderTableStore, searchParams)
}
